import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { PDFProvider } from './components/PDFProvider.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PDFProvider>
      <App />
    </PDFProvider>
  </StrictMode>
);